import { Box, LoaderNew, ModBox } from '@jfs/ui-new'
import React, { useEffect, useState } from 'react'
import { useLazyApiData, useStores } from '../../../../data/store'
import { SelectParentEntityList } from '../../Onboarding/CreateEntity/SelectParentEntityList'
import { data, flexMapperWithIndex, headerData } from './Fixtures'
import { styles } from './styles'

interface FileDataContentInterface {
  type: 'bulkUpload' | 'cardSection' | 'tid' | 'bulkConfig' | 'bulkCard' | 'bulkStore' | 'bulkTerminal'
}

const FileDataContent = React.memo(({ type }: FileDataContentInterface) => {
  const { fetchUploadedIndividualExcelFileDetail } = useStores((root) => ({
    fetchUploadedIndividualExcelFileDetail: root.bulkEntity.fetchUploadedIndividualExcelFileDetail,
  }))

  const [loader, toggleLoader] = useState(true)
  const [getFileDetails, fileDetailHandler] = useLazyApiData(fetchUploadedIndividualExcelFileDetail)

  useEffect(() => {
    getFileDetails()
  }, [getFileDetails])

  useEffect(() => {
    const fileDetailHandlerState = fileDetailHandler?.state
    if (fileDetailHandlerState === 'pending') {
      toggleLoader(true)
    } else if (fileDetailHandlerState === 'fulfilled') {
      toggleLoader(false)
    } else if (fileDetailHandlerState === 'rejected') {
      toggleLoader(false)
    }
  }, [fileDetailHandler])

  return (
    <Box {...styles.boxContainer}>
      <ModBox show={!loader} marginTop={16}>
        <SelectParentEntityList
          title={''}
          hide={false}
          data={data}
          headerTitles={headerData}
          columnFlexMapper={flexMapperWithIndex}
        />
      </ModBox>
      <ModBox show={loader}>
        <LoaderNew color={'BLUE'} />
      </ModBox>
    </Box>
  )
})

export { FileDataContent }
